module.exports = function ($state, retinaDetectionService) {
    return {
        restrict: 'E',
        scope: {
            title: '=',
            redirectTo: '=',
            retinaImage: '=',
            image: '='
        },
        link(scope) {
            scope.imageToUse = function () {
                return retinaDetectionService.isRetina ? scope.retinaImage : scope.image;
            };

            scope.redirectBack = function () {
                if (scope.redirectTo) {
                    $state.go(scope.redirectTo);
                }
            };
        },
        template: require('./sticky-header-with-image-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/sticky-header/sticky-header-with-image-directive.js
 **/